import { _ as __rest, a as __assign } from '../../tslib.es6-18cb2814.js';
import { c as classNames } from '../../index-8887fc24.js';
import { b as useMultipleSelection, a as useSelect } from '../../downshift.esm-05a86332.js';
import React__default, { useState, useEffect } from 'react';
import { B as Button } from '../../index-b7114926.js';
import { C as Checkbox } from '../../index-177b9d11.js';
import { Menu } from './Menu.js';
import { P as Popover } from '../../index-b7606a36.js';
import { Typography } from './Typography.js';
import { s as styles } from '../../FilterSelect.module-4adba085.js';
import { A as ArrowDownIcon } from '../../ArrowDownIcon-fbdb97a6.js';
import '../../countries-34fea817.js';
import '../../index-aa64515a.js';
import 'react-router-dom';
import '../../skeleton.module-7c98b8f8.js';
import '../../ThemeProvider-e3ab770b.js';
import '../../useId-f4885202.js';
import '../../CheckIcon-322b1ac3.js';
import '../../ChevronDownIcon-3390282e.js';
import '../../ChevronRightIcon-b72559d2.js';
import '../../index-31e21392.js';
import '../../CloseIcon-25692563.js';
import './TextInput.js';
import '../../useCombinedRefs-56aeb9e7.js';
import './IconButton.js';
import '../../TextInput.module-7e116b65.js';
import 'react-spring';
import 'react/jsx-runtime';
import 'react-dom';
import '../../useOrchard-45cfc194.js';
import './TextLink.js';
import '../../ResizeObserver-d78e3707.js';
import '../../CircleAlertIcon-a6cd83ad.js';
import '../../InfoIcon-22134611.js';

var labelId = "filter-select-label-".concat((Math.random() * 100).toFixed(4));
var FilterSelect = React__default.forwardRef(function FilterSelect(_a, ref) {
    var _b, _c;
    var label = _a.label, items = _a.items, className = _a.className, _d = _a["data-testid"], testId = _d === void 0 ? "filter-select" : _d, disabled = _a.disabled, isSkeleton = _a.isSkeleton, itemClassName = _a.itemClassName, itemLabelClassName = _a.itemLabelClassName, extraItemLabelClassName = _a.extraItemLabelClassName, labelGroupClassName = _a.labelGroupClassName, withSearch = _a.withSearch, customSelectedValueContent = _a.customSelectedValueContent, _e = _a.popoverSize, popoverSize = _e === void 0 ? "parent" : _e, _f = _a.popoverPlacement, popoverPlacement = _f === void 0 ? "bottom" : _f, props = __rest(_a, ["label", "items", "className", "data-testid", "disabled", "isSkeleton", "itemClassName", "itemLabelClassName", "extraItemLabelClassName", "labelGroupClassName", "withSearch", "customSelectedValueContent", "popoverSize", "popoverPlacement"]);
    var _g = {
        handleSelectedItemChange: props.type === "single" ? props.handleSelectedItemChange : undefined,
        initialSelectedItem: props.type === "single" ? props.initialSelectedItem : undefined,
        selectedItemProp: props.type === "single" ? props.selectedItem : undefined,
        handleSelectedItemsChange: props.type === "multi" ? props.handleSelectedItemsChange : undefined,
        initialSelectedItems: props.type === "multi" ? props.initialSelectedItems : undefined,
        selectedItemsProp: props.type === "multi" ? props.selectedItems : undefined,
        minimumSelectedItems: props.type === "multi" ? props.minimumSelectedItems : undefined,
    }, handleSelectedItemChange = _g.handleSelectedItemChange, initialSelectedItem = _g.initialSelectedItem, selectedItemProp = _g.selectedItemProp, handleSelectedItemsChange = _g.handleSelectedItemsChange, initialSelectedItems = _g.initialSelectedItems, selectedItemsProp = _g.selectedItemsProp, minimumSelectedItems = _g.minimumSelectedItems;
    var _h = useState(items.filter(function (i) {
        return initialSelectedItems === null || initialSelectedItems === void 0 ? void 0 : initialSelectedItems.some(function (s) { return s.value === i.value; });
    }) || []), selectedItemsState = _h[0], setSelectedItemsState = _h[1];
    var _j = useState(), searchTerm = _j[0], setSearchTerm = _j[1];
    useEffect(function () {
        if (selectedItemsProp) {
            setSelectedItemsState(selectedItemsProp);
        }
    }, [selectedItemsProp]);
    var _k = useMultipleSelection({
        selectedItems: selectedItemsState,
        onSelectedItemsChange: function (_a) {
            var newSelectedItems = _a.selectedItems;
            if (minimumSelectedItems &&
                newSelectedItems &&
                newSelectedItems.length < minimumSelectedItems) {
                return;
            }
            var deduped = newSelectedItems === null || newSelectedItems === void 0 ? void 0 : newSelectedItems.reduce(function (arr, curr) {
                if (!arr.some(function (v) { return v.value === curr.value; }))
                    arr.push(curr);
                return arr;
            }, []);
            setSelectedItemsState(deduped || []);
            handleSelectedItemsChange && handleSelectedItemsChange(deduped);
        },
    }), getDropdownProps = _k.getDropdownProps, addSelectedItem = _k.addSelectedItem, removeSelectedItem = _k.removeSelectedItem, selectedItems = _k.selectedItems, setSelectedItems = _k.setSelectedItems;
    var _l = useSelect({
        stateReducer: function (state, actionAndChanges) {
            var type = actionAndChanges.type, changes = actionAndChanges.changes;
            // this prevents the menu from being closed when the user selects an item with 'Enter' or mouse
            switch (type) {
                case useSelect.stateChangeTypes.MenuKeyDownEnter:
                case useSelect.stateChangeTypes.MenuKeyDownSpaceButton:
                case useSelect.stateChangeTypes.ItemClick:
                    if (props.type === "multi") {
                        if (changes.selectedItem) {
                            var existingItem = selectedItems.find(function (i) { var _a; return i.value === ((_a = changes.selectedItem) === null || _a === void 0 ? void 0 : _a.value); });
                            if (existingItem) {
                                removeSelectedItem(changes.selectedItem);
                            }
                            else {
                                addSelectedItem(changes.selectedItem);
                            }
                        }
                        return __assign(__assign({}, changes), { isOpen: state.isOpen, highlightedIndex: state.highlightedIndex, inputValue: "" });
                    }
                    return changes;
                default:
                    return changes; // otherwise business as usual.
            }
        },
        items: items,
        initialSelectedItem: initialSelectedItem,
        onSelectedItemChange: function (_a) {
            var selected = _a.selectedItem;
            if (props.type === "single") {
                handleSelectedItemChange && handleSelectedItemChange(selected);
            }
        },
    }), isOpen = _l.isOpen, selectedItem = _l.selectedItem, getMenuProps = _l.getMenuProps, highlightedIndex = _l.highlightedIndex, getItemProps = _l.getItemProps, selectItem = _l.selectItem, getToggleButtonProps = _l.getToggleButtonProps, closeMenu = _l.closeMenu;
    useEffect(function () {
        if (selectedItemProp !== undefined)
            selectItem(selectedItemProp);
    }, [selectItem, selectedItemProp]);
    useEffect(function () {
        if (selectedItemsProp)
            setSelectedItems(selectedItemsProp);
    }, [selectedItemsProp, setSelectedItems]);
    useEffect(function () {
        if (disabled)
            closeMenu();
    }, [disabled, closeMenu]);
    return (React__default.createElement("div", { className: styles.wrapper },
        React__default.createElement(Popover, { isOpen: isOpen, onClose: closeMenu, placement: popoverPlacement, size: popoverSize, alwaysInDom: true, removePadding: true, content: React__default.createElement(Menu, { noPadding: true },
                React__default.createElement(Menu.List, __assign({}, getMenuProps((_b = {},
                    _b["aria-labelledby"] = labelId,
                    _b)), { className: styles.menuList, "data-testid": testId && "".concat(testId, "-popover-menu") }),
                    withSearch && (React__default.createElement(Menu.Search, { "data-testid": "filter-select-search", id: "".concat(labelId, "-search"), label: "Search", onSearchQueryChange: setSearchTerm, debounceDelay: 0 })),
                    items
                        .filter(function (item) {
                        return !searchTerm ||
                            (typeof item.label === "string" &&
                                item.label
                                    .toLowerCase()
                                    .includes(searchTerm.toLowerCase()));
                    })
                        .map(function (item, index) {
                        var _a;
                        return (React__default.createElement(Menu.Item, __assign({ className: styles.menuItem, highlighted: highlightedIndex === index, selected: (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.value) === item.value, key: "".concat(item).concat(index), label: item.label, "data-testid": testId && "".concat(testId, "-popover-item-").concat(index) }, getItemProps({
                            item: item,
                            index: index,
                        }), { onClick: function () {
                                if (props.type === "single") {
                                    selectItem(item);
                                    closeMenu();
                                    return;
                                }
                                var existingItem = selectedItems.find(function (i) { return i.value === item.value; });
                                if (existingItem) {
                                    removeSelectedItem(item);
                                }
                                else {
                                    addSelectedItem(item);
                                }
                            } }),
                            React__default.createElement("span", { className: classNames((_a = {},
                                    _a[styles.selected] = (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.value) === item.value,
                                    _a), styles.extraLabel, itemClassName) },
                                props.type === "multi" ? (React__default.createElement(Checkbox, { checked: selectedItems
                                        .map(function (i) { return i.value; })
                                        .includes(item.value), id: "multi-select-".concat(index), "data-testid": "multi-select-check-".concat(index), variant: "small", wrapperClassName: styles.checkbox, disabled: selectedItems
                                        .map(function (i) { return i.value; })
                                        .includes(item.value) &&
                                        selectedItems.length <= (minimumSelectedItems || 0) })) : undefined,
                                React__default.createElement("div", { className: classNames(styles.labelGroup, labelGroupClassName) },
                                    React__default.createElement("span", { className: classNames(itemLabelClassName) }, item.label),
                                    React__default.createElement("span", { className: classNames(extraItemLabelClassName) }, item.extraLabel)))));
                    }))) },
            React__default.createElement("div", { className: styles.dropdownPositionRef })),
        React__default.createElement(Button, __assign({ className: className, ref: ref, variant: "secondary", color: "interface", disabled: disabled, isSkeleton: isSkeleton }, getToggleButtonProps(getDropdownProps()), { "data-testid": testId && "".concat(testId, "-button") }),
            React__default.createElement("span", { className: styles.filterButton, id: labelId },
                React__default.createElement(Typography, { as: "span", className: styles.label, "data-testid": testId && "".concat(testId, "-label") }, label),
                customSelectedValueContent ? (customSelectedValueContent(selectedItem)) : (React__default.createElement(LabelValues, { selectedItems: props.type === "single"
                        ? selectedItem && [selectedItem]
                        : selectedItems })),
                React__default.createElement(ArrowDownIcon, { className: classNames(styles.arrow, (_c = {}, _c[styles.rotate] = isOpen, _c)) })))));
});
var LabelValues = function (_a) {
    var selectedItems = _a.selectedItems;
    if (!(selectedItems === null || selectedItems === void 0 ? void 0 : selectedItems.length)) {
        return React__default.createElement(React__default.Fragment, null);
    }
    var renderItem = function (selectedItem) {
        return typeof selectedItem.label === "string" ? (React__default.createElement(Typography, { as: "p", className: styles.value }, selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.label)) : (React__default.createElement(React__default.Fragment, null, selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.label));
    };
    if (selectedItems.length === 1) {
        return renderItem(selectedItems[0]);
    }
    return (React__default.createElement(Typography, { as: "p", className: styles.value }, selectedItems.length));
};

export { FilterSelect };
